<template>
    <div class="CS1">
        <div class="CS1-video">
            <video src="@/assets/video1.mp4" type="video/mp4" autoplay="autoplay" muted="muted" loop="loop"></video>
        </div>
        <div class="video-blur"></div>
        <div class="CS1-info">
                <div class="CS1-text-1">WELCOME <span>TO .</span></div>
                <div class="CS1-text-2">WUSTONE</div>
                <div class="CS1-text-3">WUSTONE은 사람을 위한<br>새로운 서비스를 만들어갑니다.</div>
        </div>

    </div>
</template>
<script>
    export default {
        name: "CompanySlide1",

    }
</script>
<style lang="scss" scoped>
    .CS1 {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

        .CS1-video {
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;

            video {
                width: 100%;
                object-fit: contain;
            }
        }
        .video-blur {
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            position: absolute;
            top: 0;
            left: 0;
        }
        .CS1-info {
            width: 1500px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateY(-50%) translateX(-50%);
            padding-left: 80px;
            box-sizing: border-box;
            border-left: 15px solid rgba(255,255,255,0.7);
            .CS1-text-1 {
                font-size: 6vh;
                font-weight: 900;
                color: rgba(255,255,255,0.7);
                margin-bottom: 20px;
                span{
                    color: rgba(232,192,50,0.7);
                }
            }
            .CS1-text-2 {
                font-size: 12vh;
                font-weight: 900;
                color: rgba(255,255,255,0.7);
                margin-bottom: 200px;
            }
            .CS1-text-3 {
                font-size: 6vh;
                font-weight: 500;
                color: rgba(255,255,255,0.7);
            }
        }
    }
</style>